import { useTranslation } from 'react-i18next';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import { EIntegrationConnectionState } from '@feathr/blackbox';
import { toast } from '@feathr/components';
import { errorMessage } from '@feathr/hooks';

/** Disconnects the integration and applies the new state. Rejects on failure, so the confirm modal stays open. */
export function useDisconnect(integration: BlackbaudRaisersEdgeIntegration): () => Promise<void> {
  const { t } = useTranslation();

  return async function handleDisconnect(): Promise<void> {
    try {
      await integration.disconnectIntegration();
      // The PATCH asked for this state; apply it as saved so no reload is needed.
      integration.set({ state: EIntegrationConnectionState.disconnected }, false);
    } catch (error) {
      toast(
        t('Something went wrong while trying to disconnect your integration: {{- error}}', {
          error: errorMessage(error, t),
        }),
        { type: 'error' },
      );
      throw error;
    }

    toast(t('Your integration has been successfully disconnected.'), { type: 'success' });
  };
}
